import { escapeRegExp } from 'lodash';
import { isEscapedRegExp } from 'src/utils';

import { useParamQuery } from './useParamQuery';

/*
 * This hook is an upgraded version of useFilterAndSorting.ts, intended for use with freeSearch type filters.
 * freeSearch allows multiple search values without suggestions.
 */
export const useSearchFilter = () => {
  const { getParamsValue, onChangeParams } = useParamQuery();

  const handleOnChangeFilterKeyword = (
    data: string | string[],
    key: string = 'name.regexp',
  ) => {
    const encodedString = Array.isArray(data)
      ? data
          .filter((val, index) => data.indexOf(val) === index)
          .map((value1) =>
            isEscapedRegExp(value1) ? value1 : escapeRegExp(value1),
          )
      : escapeRegExp(data);
    onChangeParams(key, encodedString);
  };

  const handleOnRemoveFilterKeyword = (
    value: string,
    key: string = 'name.regexp',
  ) => {
    const newKeywordArray = getParamsValue(key).filter(
      (name) => name !== value,
    );
    onChangeParams(key, newKeywordArray);
  };

  return {
    handleOnChangeFilterKeyword,
    handleOnRemoveFilterKeyword,
  };
};
